// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const count_WIKI_REVIEW_RATINGS = ["%(count)s hodnocen\u00ed", "%(count)s hodnocen\u00ed", "%(count)s hodnocen\u00ed"];
export const WIKI_REVIEW_TITLE_SUFFIX = ": recenze a zku\u0161enosti";
